import script from "./SideNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./SideNavigation.vue?vue&type=script&setup=true&lang=js"

import "./SideNavigation.vue?vue&type=style&index=0&id=cac0623a&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cac0623a"]])

export default __exports__